import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import ButtonTable from '../common/table/buttonTable';

import {
	setModoTela, initForm
} from './contratoItemActions';

class ContratoItemForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='id_hospital_convenio'
								component={Select}
								options={this.props.listaConvenio.filter(item => item.id_hospital == this.props.id_hospital)}
								label='Convênio *'
								cols='12 12 6 6'
								placeholder='Selecione'
								readOnly={readOnly} />

							<Field
								name='id_exame'
								component={Select}
								options={this.props.listaExame}
								label='Exame *'
								cols='12 12 6 6'
								placeholder='Selecione'
								readOnly={readOnly} />
						</Row>

						<Row>
							
							<Field
								maxWidth={180}
								name='valor'
								component={LabelAndInputNumber}
								label='Valor Normal' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								maxWidth={180}
								name='valor_plantao'
								component={LabelAndInputNumber}
								label='Valor para Plantão' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
							
							<Field
								maxWidth={180}
								name='percentual_imposto'
								component={LabelAndInputNumber}
								label='Percentual de Imposto' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								casas={2} />
								
						</Row>

						<Row>
							<Field
								name='sigla_exame1'
								component={LabelAndInput}
								label='Sigla do Exame'
								cols='6 4 3 2'
								placeholder='Selecione'
								readOnly={'readOnly'} />
							
							<Field
								name='observacao_exame1'
								component={LabelAndInput}
								label='Observação no Exame'
								cols='6 4 3 3'
								placeholder='Selecione'
								readOnly={'readOnly'} />
						
							<Field
								name='sigla_exame2'
								component={LabelAndInput}
								label='Sigla'
								cols='6 4 3 2'
								placeholder='Selecione'
								readOnly={'readOnly'} />

							<Field
								name='observacao_exame2'
								component={LabelAndInput}
								label='Observação no Exame'
								cols='6 4 3 3'
								placeholder='Selecione'
								readOnly={'readOnly'} />
						</Row>


						{(this.props.formularioValues.regras || []).map((regra, i) => {
							return (
								<div key={regra.id}>

									<Row alignCenter style={{ alignItems: 'center', marginBottom: 16 }}>
										<div style={{ flex: 1, height: 1, backgroundColor: '#ccc' }} />
										{i == 0 &&
										<label style={{ marginHorizontal: 8, paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0, paddingLeft: 4, paddingRight: 4 }}>
											Condições
										</label>}
										<div style={{ flex: 1, height: 1, backgroundColor: '#ccc' }} />
									</Row>

									{regra.itens.map((item, j) => {

										return (
											<Row key={item.id}>
												<label 
													style={{
														marginTop: 18,
														padding: 8,
														width: 40,
														fontSize: 18,
														color: '#545454',
														fontWeight: 'bold',
														display: 'flex',
														justifyContent: 'center',
														alignItems: 'center'
													}}>{j == 0 ? 'Se' : 'e'}</label>

												<Select
													options={[
														{ id: 'sigla', valor : 'Sigla' },
														{ id: 'observacao', valor : 'Observação' }
													]}
													label={'Coluna'} 
													placeholder='Informe'
													cols='1 1 1 1'
													minWidth={250}
													readOnly={readOnly}
													value={item.tipo}
													onChange={value => {
														this.props.initForm({
															...this.props.formularioValues,
															regras: this.props.formularioValues.regras.map(regraAux => {
																if (regraAux.id == regra.id) {
																	return {
																		...regra,
																		itens: regra.itens.map(itemAux => {
																			if (item.id == itemAux.id) {
																				return {
																					...item,
																					tipo: value
																				};
																			} else {
																				return itemAux
																			}
																		})
																	};
																} else {
																	return regraAux;
																}

															})
														});
													}} />
												
												<Select
													options={[
														{ id: 'contem', valor: 'Contém' },
														{ id: 'nao_contem', valor: 'Não Contém' }
													]}
													label={'Condição'} 
													placeholder='Informe'
													cols='1 1 1 1'
													minWidth={200}
													readOnly={readOnly}
													value={item.condicao}
													onChange={value => {
														this.props.initForm({
															...this.props.formularioValues,
															regras: this.props.formularioValues.regras.map(regraAux => {
																if (regraAux.id == regra.id) {
																	return {
																		...regra,
																		itens: regra.itens.map(itemAux => {
																			if (item.id == itemAux.id) {
																				return {
																					...item,
																					condicao: value
																				};
																			} else {
																				return itemAux
																			}
																		})
																	};
																} else {
																	return regraAux;
																}

															})
														});
													}} />
													
												<LabelAndInput
													label={'Valor'} 
													placeholder='Informe'
													cols='4 4 4 4'
													readOnly={readOnly}
													value={item.valor}
													onChange={data => {
														this.props.initForm({
															...this.props.formularioValues,
															regras: this.props.formularioValues.regras.map(regraAux => {
																if (regraAux.id == regra.id) {
																	return {
																		...regra,
																		itens: regra.itens.map(itemAux => {
																			if (item.id == itemAux.id) {
																				return {
																					...item,
																					valor: data.target.value
																				};
																			} else {
																				return itemAux
																			}
																		})
																	};
																} else {
																	return regraAux;
																}

															})
														});
													}} />
												
												{!readOnly &&
												<div style={{ width: 100, paddingTop: 30 }}>
													<ButtonTable
														type={'danger'}
														icon={'fas fa-trash-alt'}
														visible={true}
														height={38}
														event={() => {
															this.props.initForm({
																...this.props.formularioValues,
																regras: this.props.formularioValues.regras.map(regraAux => {
																	if (regraAux.id == regra.id) {
																		return {
																			...regra,
																			itens: regra.itens.filter(itemAux => item.id != itemAux.id)
																		};
																	} else {
																		return regraAux;
																	}
																}).filter(regra => regra.itens.length)
															});
														}} />
													
													{j == regra.itens.length -1 &&
													<ButtonTable
														type={'success'}
														icon={'fas fa-plus'}
														visible={true}
														height={38}
														event={() => {
															this.props.initForm({
																...this.props.formularioValues,
																regras: this.props.formularioValues.regras.map(regraAux => {
																	if (regraAux.id == regra.id) {
																		let itens = regra.itens.map(itemAux => itemAux);
																		itens.push({
																			id: new Date().getTime(),
																		});
																		return {
																			...regra,
																			itens: itens
																		};
																	} else {
																		return regraAux;
																	}
																})
															});
														}} />}
												</div>}
											</Row>
										);
									})}
									
									<Row>
										<label style={{ paddingTop: 8, width: 40 }}></label>
										<Select
											options={[
												{ id: 1, valor: 1 },
												{ id: 2, valor: 2 },
												{ id: 3, valor: 3 },
												{ id: 4, valor: 4 }
											]}
											label={'Peso'} 
											placeholder='Informe'
											cols='1 1 1 1'
											minWidth={200}
											readOnly={readOnly}
											value={regra.peso}
											onChange={value => {
												this.props.initForm({
													...this.props.formularioValues,
													regras: this.props.formularioValues.regras.map(regraAux => {
														if (regraAux.id == regra.id) {
															return {
																...regra,
																peso: value
															};
														} else {
															return regraAux;
														}
													})
												});
											}} />
									</Row>
								</div>
							);
						})}

						{!readOnly &&
						<Row alignCenter>
							<div class='col-md-4' style={{ marginTop: 24, marginBottom: 24 }}>
								<button
									type='button'
									class='btn btn-primary btn-block'
									onClick={() => {
										let regras = (this.props.formularioValues.regras || []).map(regra => regra);
										regras.push({
											id: new Date().getTime(),
											itens: [{
												id: new Date().getTime(),
											}]
										});
										this.props.initForm({
											...this.props.formularioValues,
											regras: regras
										});
									}}>
									<i class='fa fa-plus'></i> Adicionar Condição
								</button>
							</div>
						</Row>}
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Remover'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

ContratoItemForm = reduxForm({form: 'contratoItemForm', destroyOnUnmount: false})(ContratoItemForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('contratoItemForm')(state),
	registro: state.contratoItem.registro,
	listaConvenio: state.hospitalConvenio.listaSelect,
	listaExame: state.exame.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ContratoItemForm);
